import { AxiosInstance } from 'axios';
import { apiBaseUrl } from './baseUrl';

/**
 * Alerts of the backlog and the sweep. Mirrors AlertDto on the server; new ones arrive live
 * over the alert hub.
 */

export type AlertSeverity = 'Info' | 'Warning' | 'Error';

export interface Alert {
    id: string;
    kind: string;
    severity: AlertSeverity;
    title: string;
    message?: string | null;
    customer?: string | null;
    environment?: string | null;
    code?: string | null;
    /** A dashboard path to open, such as a filtered issue list. */
    link?: string | null;
    createdAt: string;
    acknowledgedAt?: string | null;
    acknowledgedBy?: string | null;
}

/** Path of the hub pushing new alerts. Must match AlertHub.Path. */
export const alertHubUrl = `${apiBaseUrl.replace(/\/+$/, '')}/hubs/alerts`;

/** Must match AlertHub.AlertMethod. */
export const ALERT_METHOD = 'alert';

// The generated client's axios instance hands the body back as text.
const body = <T>(data: unknown): T =>
    (typeof data === 'string' && data.length > 0 ? JSON.parse(data) : data) as T;

export const getAlerts = async (
    axios: AxiosInstance,
    take = 50,
    signal?: AbortSignal
): Promise<Alert[]> =>
    body<Alert[]>((await axios.get(`/Alerts?take=${take}`, { signal })).data);

export const acknowledgeAlerts = async (
    axios: AxiosInstance,
    ids: string[]
): Promise<void> => {
    await axios.post('/Alerts/acknowledge', ids);
};
